import { useEffect } from "react";
import {connect} from "react-redux";
import { getHomePosts } from "../../redux/actions/actions.js";
import Tweet from "./Tweet";
import Loading from "../loading/Loading.js";

const Home_TweetsSection = (props) => {
    useEffect(() => {
        props.onGetHomePosts();
        const updatePostsInterval = setInterval(() => {
            props.onGetHomePosts()
        },3000);
        return () => clearInterval(updatePostsInterval);
    },[])
    return(
    // return props.isPending ?
    // (
    //     <div className="main_content_section_main main_content_users_loading_div">
    //         <Loading type="spinningBubbles" color="rgb(77, 159, 236)" />
    //     </div>
    // ) :
    // (
        <div className="main_content_section home_tweets_section">
            {
                props.home_posts.map(post => {
                    return(
                        <Tweet key={post.id} content={post.content} date={post.post_date} user_id={post.user_id} />
                    )
                })
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        home_posts: state.getHomePosts.home_posts,
        isPending: state.getHomePosts.isPending,
        error: state.getHomePosts.error
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onGetHomePosts: () => dispatch(getHomePosts())
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Home_TweetsSection);